module.exports = __webpack_public_path__ + "static/media/web-browser.eeaf96db.svg";